import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type UserEditConfirmDeleteProps = {
  onAbort: () => void;
  onConfirm: () => void;
};

export const UserEditConfirmDelete = (props: UserEditConfirmDeleteProps) => {
  const { onAbort, onConfirm } = props;
  const { t } = useTranslation(['common']);

  const [showModal, setShowModal] = useState<boolean>(false);

  const handleAbort = () => {
    setShowModal(false);
    onAbort();
  };

  const handleConfirm = () => {
    setShowModal(false);
    onConfirm();
  };

  return (
    <>
      <Dialog open={showModal} onClose={handleAbort} maxWidth='sm'>
        <DialogTitle>{t('user:confirmDelete.header')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('user:confirmDelete.description')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAbort} variant='outlined'>
            {t('common:button.cancel')}
          </Button>
          <Button type='submit' variant='contained' disableElevation onClick={handleConfirm}>
            {t('common:button.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
      <Button variant='outlined' color='error' sx={{ mr: 1 }} onClick={() => setShowModal(true)}>
        {t('common:button.delete')}
      </Button>
    </>
  );
};
